import React from 'react';
import Hero from './components/IQAC/academic-calendar/Hero';
import Main from './components/IQAC/academic-calendar/Main';

const IqacAcademicCalendar = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacAcademicCalendar;